<template>
    <div ref="sidepanel" class="sidepanel" tabindex="-1" @blur="hidePanel">
        <a @click.prevent="hidePanel" class="close-btn">×</a>
        <h5>Keyboard shortcuts</h5>
        <p>Press Control + / to toggle this panel</p>

        <div class="hide-scrollbar">
            <div class="hotkeys-list">
                <div v-for="module in appHotkeyModules" :key="module.title" class="mt-3">
                    <h6>{{ module.title }}</h6>
                    <div v-for="item in module.hotkeys" :key="item.key" class="row m-0 px-0 py-1">
                        <div class="col-8">
                            {{ item.description }}
                        </div>
                        <div class="col-4 text-right pr-0">
                            {{ item.hotkey }}
                        </div>

                        <div v-if="item.children" class="col-12 pr-0">
                            <div v-for="child in item.children" :key="child.key" class="row m-0 py-1 pr-0">
                                <div class="col-8 pr-0">
                                    - {{ child.description }}
                                </div>
                                <div class="col-4 text-right pr-0">
                                    {{ child.hotkey }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import hotkeys from 'hotkeys-js'
import {appHotkeyModules} from '../../models/hotkeys'

export default {
    name: 'HotkeysSidePanel',
    data() {
        return {
            appHotkeyModules
        }
    },
    methods: {
        showPanel() {
            this.$refs.sidepanel.style.right = '0px'
            this.$refs.sidepanel.focus()
        },
        hidePanel() {
            this.$refs.sidepanel.style.right = '-380px'
        }
    },
    mounted() {
        hotkeys('ctrl+/', () => {
            if (this.$refs.sidepanel.style.right === '0px') {
                this.hidePanel()
            } else {
                this.showPanel()
            }
        })

        hotkeys('esc', () => {
            this.hidePanel()
        })

        this.$bus.$on('OPEN_HOTKEYS', () => this.showPanel())
    },
    beforeDestroy() {
        hotkeys.unbind('ctrl+/')
        hotkeys.unbind('esc')
        this.$bus.$off('OPEN_HOTKEYS')
    }
}
</script>

<style scoped lang="scss">
    $sidepanel-width: 380px;

    .sidepanel {
        position: fixed;
        height: 100vh;
        top: 0;
        width: $sidepanel-width;
        right: -$sidepanel-width;
        color: white;
        text-align: left;
        background-color: rgba(17, 17, 17, 0.95);
        overflow: hidden;
        transition: 0.5s;
        padding: 40px 30px 30px;
        z-index: 10000;
    }

    .sidepanel .close-btn {
        position: absolute;
        top: 0;
        right: 25px;
        font-size: 36px;

        &:hover {
            cursor: pointer;
        }
    }

    .hotkeys-list {
        max-height: calc(100vh - 200px);
        padding-bottom: 90px;
    }
</style>
